import React, { FC } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import rL from './i18n/router';
import MisDatos from './pages/MisDatos';
import Revistas from './pages/Revistas';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import Saldo from './pages/Saldo';
import PuntosTravel from './pages/PuntosTravel';
import Vales from './pages/Vales';
import ComprasTicket from './pages/ComprasTicket';
import Layout from './components/Layout';
import Ahorros from './pages/Ahorros';
import { StorageHelper } from './utils/StorageHelper';
import Tarjetas from './pages/Tarjetas';
import TarjetasOro from './pages/TarjetasOro';
import { HostProvider } from './utils/HostProvider';

if (HostProvider.isEroski()) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  import('./assets/scss/globals.scss');
} else {
  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  import('./assets/scss/globals-caprabo.scss');
}

const App: FC = (props) => {
  StorageHelper.initializeVars();

  return (
    <>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={Home} />
            <Route path="/home" element={Home} />
            <Route path="/vacio.html" element={Home} />
            <Route path="/test.html" element={Home} />
            {rL.getRutas('misdatos').map((route) => {
              return (
                <Route
                  key={route}
                  path={route}
                  element={
                    <MisDatos
                      {...props}
                      showChangeMail={false}
                      showBaja={false}
                      showChangePass={false}
                    />
                  }
                />
              );
            })}
            {rL.getRutas('revistas').map((route) => {
              return <Route key={route} path={route} element={<Revistas />} />;
            })}
            {rL.getRutas('saldo').map((route) => {
              return <Route key={route} path={route} element={<Saldo />} />;
            })}
            {rL.getRutas('fueron-oro').map((route) => {
              return <Route key={route} path={route} element={<NotFound />} />;
            })}
            {rL.getRutas('ahorros').map((route) => {
              return <Route key={route} path={route} element={<Ahorros />} />;
            })}
            {rL.getRutas('puntos-travel').map((route) => {
              return (
                <Route key={route} path={route} element={<PuntosTravel />} />
              );
            })}
            {rL.getRutas('vales').map((route) => {
              return <Route key={route} path={route} element={<Vales />} />;
            })}
            {rL.getRutas('compras').map((route) => {
              return (
                <Route key={route} path={route} element={<ComprasTicket />} />
              );
            })}
            {rL.getRutas('tarjetas').map((route) => {
              return <Route key={route} path={route} element={<Tarjetas />} />;
            })}
            {rL.getRutas('tarjeta-oro').map((route) => {
              return (
                <Route key={route} path={route} element={<TarjetasOro />} />
              );
            })}
            {rL.getRutas('change-mail').map((route) => {
              return (
                <Route
                  key={route}
                  path={route}
                  element={<MisDatos {...props} showChangeMail />}
                />
              );
            })}
            {rL.getRutas('change-pass').map((route) => {
              return (
                <Route
                  key={route}
                  path={route}
                  element={<MisDatos {...props} showChangePass />}
                />
              );
            })}
            {rL.getRutas('baja-digita').map((route) => {
              return (
                <Route
                  key={route}
                  path={route}
                  element={<MisDatos {...props} showBaja />}
                />
              );
            })}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </>
  );
};
export default App;
